
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/meme-generator/edit/[slug]",
      function () {
        return require("private-next-pages/meme-generator/edit/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/meme-generator/edit/[slug]"])
      });
    }
  